import React, { useState } from 'react';
import './ContactSkill.css';
import { FaEnvelope, FaUser, FaPhoneAlt, FaRegEdit, FaCommentDots } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';

// Country Data
const countryCodes = [
  { code: '+91', name: 'India', flag: '🇮🇳' },
  { code: '+1', name: 'USA', flag: '🇺🇸' },
  { code: '+44', name: 'UK', flag: '🇬🇧' },
  { code: '+61', name: 'Australia', flag: '🇦🇺' },
];

const ContactSkill = () => {
  const [selectedCountry, setSelectedCountry] = useState(countryCodes[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // Form state
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    verified: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.verified) return alert('Please verify CAPTCHA');

    setLoading(true);
    try {
      const response = await fetch('https://skillshap.com/connect-now', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          phone: selectedCountry.code + form.phone,
          message: form.message,
        }),
      });

      const res = await response.json();
      if (response.ok) {
        alert('Message sent successfully!');
        setForm({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
          verified: false,
        });
        setMessage('');
      } else {
        alert(res.error || 'Something went wrong');
      }
    } catch (err) {
      console.error(err);
      alert('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-us-page">
      <div className="enroll-section">
        <h2 className="enroll-heading">Get in Touch</h2>
        <p className="enroll-subtext">
          We're here to help you on your AI-powered career journey.
        </p>

        <form className="enroll-form" onSubmit={handleSubmit}>
          {/* Full Name */}
          <div className="input-icon-wrapper">
            <FaUser className="input-icon" />
            <input
              type="text"
              placeholder="Full Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Email */}
          <div className="input-icon-wrapper">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              placeholder="Email Address"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Phone with Country Dropdown */}
          <div className="phone-input-complete">
            <div className="dropdown-wrapper">
              <div
                className="selected-country"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <span>{selectedCountry.flag} {selectedCountry.code}</span>
                <IoIosArrowDown />
              </div>
              {dropdownOpen && (
                <ul className="dropdown-menu">
                  {countryCodes.map((country, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setSelectedCountry(country);
                        setDropdownOpen(false);
                      }}
                    >
                      {country.flag} {country.name} ({country.code})
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <input
              type="tel"
              placeholder="Phone Number"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              required
            />
          </div>

          {/* Subject */}
          <div className="input-icon-wrapper">
            <FaRegEdit className="input-icon" />
            <input
              type="text"
              placeholder="Subject"
              name="subject"
              value={form.subject}
              onChange={handleChange}
              required
            />
          </div>

          {/* Message Field with Counter */}
          <div className="input-icon-wrapper">
            <FaCommentDots className="input-icon" />
            <textarea
              name="message"
              placeholder="Your Message"
              maxLength="500"
              value={form.message}
              onChange={(e) => {
                setMessage(e.target.value);
                handleChange(e);
              }}
              required
            />
            <div className="char-counter">{message.length}/500</div>
          </div>

          {/* CAPTCHA Checkbox */}
          <div className="recaptcha">
            <input
              type="checkbox"
              name="verified"
              checked={form.verified}
              onChange={handleChange}
              required
            />
            <label>I am not a robot</label>
          </div>

          {/* Submit */}
          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactSkill;